import { InjectionToken } from '@angular/core';
export const LOCALIZATION = new InjectionToken('fc.gui.loc');
export const DefaultLocalization = {
    loadFailed: 'Load failed.',
    setting: 'Setting',
    submit: 'Submit',
    numericalValueRequired: 'Numerical value can\'t be emtpy',
    invalidNumericalValue: 'Numerical value is not valid',
    binaryType: 'Binary',
    decimalType: 'Decimal',
    hexadecimalType: 'Hexadecimal',
    stringType: 'String',
    numericalValueTooLong: 'Numerical value too long',
    fractionDigitsMustLessThan: 'Fraction digits must be less than ',
    canNotBeNegative: 'Can not be negative',
    valueOutOfRange: 'Numerical value is out of range',
    timeout: 'timeout',
    confirmOperationPrompt: 'Sure to do this operation?',
    confirm: 'Yes',
    cancel: 'Cancel',
    characterInputRequired: 'Character input can\'t be empty',
    character: '(Character)',
    characterOutofRange: 'Character length is out of range',
    writeValueRange: 'Write value range',
    loading: 'Loading',
    unbind: 'Unbind',
    offline: 'Offline',
    abnormal: 'Data abnormal',
    disable: 'Disable',
    permissiontip: 'You have no permission to operate.',
    conditionIsNotMetTip: 'Unsatisfied operating conditions or variable abnorma.',
    chartNoData: 'No Data Available',
    lastOneHour: 'Last one hour',
    lastTwentyFourHours: 'Last 24 hours',
    lastSevenDays: 'Last 7 days',
    lastThirtyDays: 'Last 30 days',
    lastOneYear: 'Last 1 year',
    grouped: 'Grouped',
    stacked: 'Stacked',
    passwordVerify: 'Password verifiers',
    passwordError: 'Password error',
    password: 'Password',
    passwordToolTip: 'Password error, please re-enter',
    passwordRequired: 'Password can\'t be empty',
    invalidVideoAddress: 'Invalid video address',
    unconfiguredVideoAddress: 'Unconfigured Video Address',
    weatherNotSupport: 'Location not supported',
    weatherNotAddress: 'Address not configured',
    weatherNotAvailable: 'Address not yet available'
};
